import masterVolume from './masterVolume';

// Keep any volume number inside the browser-safe 0 to 1 range.
// This prevents weird behavior if a caller passes something too high,
// negative, or not really a number at all.
function clamp01(value)
{
    if (!Number.isFinite(value)) return 0;
    if (value <= 0) return 0;
    if (value >= 1) return 1;
    return value;
}

// Shared helper for pages that want to "warm up" an audio file before it is
// actually played. This is to make every page create and preload audio
// the same way, so mobile browsers do not treat one page differently from another.
export function createPreloadedAudio(src, options = {})
{
    if (!src) return null;

    const
    {
        baseVolume = 1,
            loop = false,
            applyMaster = true,
            muted = false,
            initialVolume,
    } = options;

    // baseVolume is the file specific's own intended loudness 
    // this would be how loud the sound is if the user had their master volume at 100%.
    const resolvedBaseVolume = Number.isFinite(Number(baseVolume)) ? clamp01(Number(baseVolume)) : 1;

    try
    {
        //make a browser audio element now instead of waiting until play-time.
        // That lets us configure it, ask the browser to fetch it, and reuse the same
        // setup rules everywhere in the app.
        const audio = new Audio(src);
        audio.loop = !!loop;
        audio.muted = !!muted;

        // 'auto' tells the browser this file is expected to be needed soon, so it
        // should start loading as much as it is willing to ahead of playback.
        audio.preload = 'auto';

        // _baseVolume is a custom property used elsewhere in the site. The global
        // master-volume system reads this value and multiplies it by the user's
        // master volume setting, so pages can keep their own mix levels.
        audio._baseVolume = resolvedBaseVolume;

        try
        {
            // Give the element a sensible starting volume immediately.
            // If a caller provides initialVolume, that wins.
            // Otherwise we combine this sound's base volume with the current master volume.
            const fallbackVolume = resolvedBaseVolume * masterVolume.getMasterVolume();
            const nextVolume = Number.isFinite(Number(initialVolume)) ? clamp01(Number(initialVolume)) : fallbackVolume;
            audio.volume = nextVolume;
        }
        catch (e)
        {}

        // load() kicks off the actual preload request right away instead of waiting
        // for the browser to decide when to start.
        try
        {
            audio.load();
        }
        catch (e)
        {}

        // this connects the element to the shared master-volume controller so later
        // volume changes from the settings UI still affect preloaded sounds correctly.
        try
        {
            if (applyMaster) masterVolume.applyToElement(audio);
        }
        catch (e)
        {}
        return audio;
    }
    catch (e)
    {
        // aduio is rejected, dont crash the page, just return null so the caller can handle it.
        return null;
    }
}
